import type { ClientInfo, OAuthParams } from '@rentflowdev/api'
import { OAUTH_SESSION_STORAGE_KEY } from '../constants'

export interface OAuthState {
	params: OAuthParams
	client: ClientInfo
	accountId?: string
}

export function parseOAuthParams(searchParams: URLSearchParams): OAuthParams | null {
	const clientId = searchParams.get('client_id')
	const redirectUri = searchParams.get('redirect_uri')
	const responseType = searchParams.get('response_type')
	const state = searchParams.get('state')
	const codeChallenge = searchParams.get('code_challenge')
	const codeChallengeMethod = searchParams.get('code_challenge_method')

	if (!clientId || !redirectUri || !responseType || !state || !codeChallenge || !codeChallengeMethod) {
		return null
	}

	return {
		clientId,
		redirectUri,
		responseType,
		state,
		codeChallenge,
		codeChallengeMethod,
		scope: searchParams.get('scope') ?? '',
	}
}

export function persistOAuthState(state: OAuthState): void {
	sessionStorage.setItem(OAUTH_SESSION_STORAGE_KEY, JSON.stringify(state))
}

export function retrieveOAuthState(): OAuthState | null {
	const raw = sessionStorage.getItem(OAUTH_SESSION_STORAGE_KEY)
	if (!raw) return null
	try {
		return JSON.parse(raw) as OAuthState
	} catch {
		return null
	}
}

export function clearOAuthState(): void {
	sessionStorage.removeItem(OAUTH_SESSION_STORAGE_KEY)
}
